import HeroArticles from '@/components/HeroArticles';
import RecentArticles from '@/components/RecentArticles';
import HeroArticlesSkeleton from '@/components/skeletons/HeroArticlesSkeleton';
import { CMSContextType } from '@/types/util.types';
import { useCms } from '@/hooks/useCms';
import MetaTags from '@/components/MetaTags';
import { PAGE_META_DATA } from '@/constants/constants';
import PodcastEpisodes from '@/components/PodcastEpisodes';
import Section from '@/components/elements/Section';

function Home() {
  const { recentArticlesFeaturedCategories, featuredArticles } = useCms() as CMSContextType;

  return (
    <div data-cy='home-page-container'>
      <MetaTags title={PAGE_META_DATA.home.title} description={PAGE_META_DATA.home.description} />

      <Section>
        {featuredArticles.length > 0 ? <HeroArticles articles={featuredArticles} /> : <HeroArticlesSkeleton />}
      </Section>

      <PodcastEpisodes background='white' />
      <RecentArticles articles={recentArticlesFeaturedCategories} />
    </div>
  );
}

export default Home;
